require('./brokerFavoriteList.scss');

// @vendors
const React= require('react');
const PropTypes = require('prop-types');
const { times } = require('lodash');
const classnames = require('classnames');

// @helpers
const { formatAmount } = require('utilities/currencyHelper');
const { formatText } = require('core/i18n').i18n;

// @constants
const { 
    BROKER_FAVORITE_LIST_SIZE, 
    BROKER_FAVORITE_MAX_PRODUCT_SIZE, 
    BROKER_FAVORITE_MAX_LIST_SIZE,
    PRODUCT_TYPE_PLAN,
    PRODUCT_TYPE_STOCKS,
    PRODUCT_TYPE_FUND,
    PRODUCT_TYPE_ETF,
    PRODUCT_TYPE_WARRANTS
 } = require('constants/index');

class BrokerFavoriteList extends React.Component {
    constructor(props) {
        super(props);
        this.buildFavoriteList = this.buildFavoriteList.bind(this);
        this.getMaxProductDetails = this.getMaxProductDetails.bind(this);
        this.handleGoalPageClick = this.handleGoalPageClick.bind(this);
        this.handleWatchlistDetails = this.handleWatchlistDetails.bind(this);
    }

    handleGoalPageClick(ev) {
        const id = parseInt(ev.currentTarget.dataset.id);
        this.props.setPageNumber(id);
    }

    buildEmptyListItemNode(emptyRowsNumber) {
        const emptyList = times(emptyRowsNumber, index => {
            return (
                <div key={index} className="broker-favorite-list__info-block broker-favorite-list__info-block--disabled" onClick={this.props.handleWatchlistModalToggle}>
                    <div className="broker-favorite-list__disabled-header">
                        <span>{formatText('brokerFavoriteList-brokerFavoriteList_emptyListTitle')}</span>             
                        <span className="broker-favorite-list__disabled-header-right-content">
                            <i className="icon broker-favorite-list__disabled-header-right-content-icon" />
                        </span>                        
                    </div>
                </div>
            );
        });

        return emptyList;
    }

    getMaxProductDetails(product) {
        let maximumProductVariation = '';
        const variationAmount = product.get('variation');
        const formattedVariationAmount = formatAmount(variationAmount);
        const variationClassName = classnames({
            'icon-alza broker-favorite-list__info-footer-arrow--up': (variationAmount > 0),
            'icon-baja broker-favorite-list__info-footer-arrow--down': (variationAmount < 0),
        });
        const productName = product.get('type') && product.get('type').toLowerCase();

        switch(productName) {
            case PRODUCT_TYPE_STOCKS:
            case PRODUCT_TYPE_ETF:
                maximumProductVariation = product.get('ticker');
                break;
            case PRODUCT_TYPE_WARRANTS:
            case PRODUCT_TYPE_FUND:
                maximumProductVariation = product.get('isin');
                break;
            case PRODUCT_TYPE_PLAN:
                maximumProductVariation = product.get('dgsCode');
                break;
            default:
                return ;
        }

        return (
            <div className="broker-favorite-list__info-footer">
                <span>{maximumProductVariation}</span>
                <span className="broker-favorite-list__info-footer-right-content">
                    <i className={variationClassName} />
                    <span className="broker-favorite-list__info-footer-right-content-text">{formattedVariationAmount} %</span>
                </span>
            </div>
        )
    }

    productCount(count) {
        return (
            <span>
                <span>{count}/{BROKER_FAVORITE_MAX_PRODUCT_SIZE}</span>
                <i className="icon broker-favorite-list__star"></i>
            </span>
        )     
    }

    buildPagination(size, pageNumber, handlePageClick) {
            const totalCircle = Math.floor(size/BROKER_FAVORITE_LIST_SIZE) + 1;
            const circleContent = times(totalCircle, index => {
            const className = classnames('broker-favorite-list__circle', {
                'broker-favorite-list__circle--active': pageNumber === (index + 1),
            });
            return (
                <div className={className} data-id={index + 1} onClick={handlePageClick} />
            );
        });

        return (
            <div className="broker-favorite-list__pagination">
                {circleContent}
            </div>
        );
    }

    paginate(array, pageSize, pageNumber) {
        const position = pageNumber - 1;
        return array.slice(position * pageSize, (position + 1) * pageSize);
    }

    handleWatchlistDetails(listId) {
        this.props.showWatchlistDetails(listId);
    }

    buildFavoriteList() {
        const { favoriteContent, pageNumber } = this.props;
        let emptyListItems = '';
        const listContent = this.paginate(favoriteContent, BROKER_FAVORITE_LIST_SIZE, pageNumber);
        const list = listContent.map((content, index) => {
            const listId = content.get('id');
            const listName = content.get('name');
            const totalProductCount = !!content.get('productsCount') ? content.get('productsCount') : 0;
            const productsCountDetails = this.productCount(totalProductCount);
            const productDetails = !!content.get('featuredProduct') ? this.getMaxProductDetails(content.get('featuredProduct')) : '';
            
            return (
                <div key={index} className="broker-favorite-list__info-block" onClick={() => this.handleWatchlistDetails(listId)}>
                    <div className="broker-favorite-list__info-header">
                        <span className="broker-favorite-list__info-header-title">{listName}</span>
                        <span className="broker-favorite-list__info-header-right-content">
                            {productsCountDetails}                            
                        </span>
                    </div>
                    {productDetails}
                </div>
            )
        });
        
        const emptyRowsNumber = BROKER_FAVORITE_LIST_SIZE - listContent.size;
        
        if ((emptyRowsNumber + favoriteContent.size) < BROKER_FAVORITE_MAX_LIST_SIZE && emptyRowsNumber > 0) {
            emptyListItems = this.buildEmptyListItemNode(emptyRowsNumber);
        } else if (emptyRowsNumber > 0) {
            emptyListItems = this.buildEmptyListItemNode(BROKER_FAVORITE_MAX_LIST_SIZE - favoriteContent.size)
        }

        return (
            <div className="broker-favorite-list__item">
                <div className="row">
                    {list}
                    {emptyListItems}
                </div>
            </div>
        );

    }

    render() {
        const { favoriteContent, pageNumber } = this.props;
        let favoriteList = '', goalPagination = '';

        if(favoriteContent.size > 0) {
            favoriteList = this.buildFavoriteList();
            goalPagination = this.buildPagination(favoriteContent.size, pageNumber, this.handleGoalPageClick);
        }

        return (
            <section className="broker-favorite-list">
                <div className="broker-favorite-list__body">
                    {favoriteList}
                    {goalPagination}
                </div>
            </section>
        );
    }
}

BrokerFavoriteList.propTypes = {
    favoriteContent: PropTypes.array.isRequired,
    handleWatchlistModalToggle: PropTypes.func,
    pageNumber: PropTypes.number,
    setPageNumber: PropTypes.func,
    showWatchlistDetails: PropTypes.func,
};

BrokerFavoriteList.defaultProps = {
    emptyStateLink: PropTypes.string.isRequired,

};

module.exports = BrokerFavoriteList;
